import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const uMCollectorScheduleApi = createApi({
  reducerPath: 'uMCollectorScheduleApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['CollectorSchedule'],
  endpoints: (builder) => ({
    getCollectorSchedules: builder.query({
      query: (params) => ({
        url: '/utils/collector-schedule/',
        params,
      }),
      providesTags: ['CollectorSchedule'],
    }),

    getAvailableCollectorTasks: builder.query({
      query: () => ({
        url: '/utils/collector-schedule/available-tasks/',
      }),
    }),

    createCollectorSchedule: builder.mutation({
      query: (body) => ({
        url: '/utils/collector-schedule/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['CollectorSchedule'],
    }),

    updateCollectorScheduleById: builder.mutation({
      query: ({ id, body }) => ({
        url: `/utils/collector-schedule/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['CollectorSchedule'],
    }),

    deleteCollectorScheduleById: builder.mutation({
      query: (id) => ({
        url: `/utils/collector-schedule/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CollectorSchedule'],
    }),

    triggerCollectorScheduleById: builder.mutation({
      query: (id) => ({
        url: `/utils/collector-schedule/${id}/trigger/`,
        method: 'POST',
      }),
      invalidatesTags: ['CollectorSchedule'],
    }),
  }),
});

export const {
  useGetCollectorSchedulesQuery,
  useGetAvailableCollectorTasksQuery,
  useCreateCollectorScheduleMutation,
  useUpdateCollectorScheduleByIdMutation,
  useDeleteCollectorScheduleByIdMutation,
  useTriggerCollectorScheduleByIdMutation,
} = uMCollectorScheduleApi;
